/**
 * Web ilan portali UI bayrağı — Django `PP_WEB_ILAN_PORTAL_UI_ENABLED` → topbar `window.PP_WEB_ILAN_PORTAL_UI_ENABLED`.
 */
export function isWebIlanPortalUiEnabled() {
  if (typeof window === 'undefined') return false;
  return window.PP_WEB_ILAN_PORTAL_UI_ENABLED === true;
}
